import type { ReactElement } from 'react';
import { TailSpin } from 'react-loader-spinner';

interface LoaderProps {
  heading?: string; // Optional heading
}

export default function Loader({ heading }: LoaderProps): ReactElement {
  return (
    <div className="flex flex-col items-center justify-center w-full mx-auto text-center">
      <TailSpin
        height="120"
        width="120"
        color="#00214D"
        ariaLabel="tail-spin-loading"
        radius="1"
        visible={true}
      />
      {heading && (
        <p className="mt-4 text-lg font-semibold text-gray-700">{heading}</p>
      )}
    </div>
  );
}
